module.exports = __webpack_public_path__ + "img/heart.024aba25.jpg";